import React from 'react'

import { pixKeyTypeMapper } from '../../../../utils/validatePixType'

import * as S from './styles'

export const PixUpdateModal = ({ pixInfo, modalRef, onSubmit, onClose, isLoading, thirdPartyRecipient, cancellationData }) => {
  const { fullName, CPF } = cancellationData || {}
  const parsedFullName = fullName ?? cancellationData?.cancellationRequest?.paymentInformation?.recipient
  const parsedCPF = CPF ?? cancellationData?.cancellationRequest?.paymentInformation?.CPF

  return (
    <S.StyledModal ref={modalRef}>
      <S.ModalWrapper className="ph-no-capture">
        <S.HeaderWrapper>
          <S.Title>Confirmação</S.Title>
        </S.HeaderWrapper>

        <S.Description>
          Eu concordo em receber o reembolso nos dados inseridos abaixo. Essa ação é irreversível, por favor, valide os dados
          antes da confirmação.
        </S.Description>

        <S.Row>
          Beneficiário:<strong> {thirdPartyRecipient ? pixInfo?.recipient : parsedFullName}</strong>
          <br />
          CPF:<strong> {thirdPartyRecipient ? pixInfo?.CPF : parsedCPF}</strong>
          <br />
          Chave PIX ({pixKeyTypeMapper[pixInfo?.pixType]}): <strong> {pixInfo?.pixKey}</strong>
        </S.Row>

        <S.ButtonRow>
          <S.CancelButton onClick={onClose} disabled={isLoading}>
            Cancelar
          </S.CancelButton>{' '}
          <S.ConfirmButton onClick={onSubmit} disabled={isLoading}>
            {isLoading ? (
              <S.SpinnerCenter>
                <S.SmallSpinner />
              </S.SpinnerCenter>
            ) : (
              'Confirmar'
            )}
          </S.ConfirmButton>
        </S.ButtonRow>
      </S.ModalWrapper>
    </S.StyledModal>
  )
}
